/*
Description: Reports the on-screen keyboard height on mobile web, 0 otherwise.

Mobile browsers (iOS Safari, Android Chrome) shrink only the visual viewport when
the keyboard opens; 100vh and position: fixed; bottom: 0 still resolve against the
full layout viewport, so bottom-anchored sheets end up behind the keyboard.
react-native-web's Keyboard never emits keyboardDidShow, so read visualViewport.
*/

import { useState, useEffect } from 'react';
import { isMobileWeb } from '@global/screens';

const useMobileWebKeyboardHeight = () => {
  const [keyboardHeight, setKeyboardHeight] = useState(0);

  useEffect(() => {
    const viewport =
      typeof window !== 'undefined' ? window.visualViewport : null;
    if (!isMobileWeb || !viewport) {
      return undefined;
    }
    const onResize = () => {
      const covered = window.innerHeight - viewport.height - viewport.offsetTop;
      // ignore small deltas from the browser toolbar collapsing
      setKeyboardHeight(covered > 100 ? covered : 0);
    };
    viewport.addEventListener('resize', onResize);
    viewport.addEventListener('scroll', onResize);
    return () => {
      viewport.removeEventListener('resize', onResize);
      viewport.removeEventListener('scroll', onResize);
    };
  }, []);

  return keyboardHeight;
};

export default useMobileWebKeyboardHeight;
